import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";
import { LanguageService } from "libraries/service/language/language.service";
import { EnvironmentNameService } from "libraries/service/error-tracing/environment-name.service";

@NgModule({
    imports: [
        CommonModule,
    ],
    providers: [
        ErrorTracingService,
        LanguageService,
        EnvironmentNameService,
    ]
})
export class ErrorTracingModule {
}
